import { applicationRoles } from '../constants/actionTypes'

const initialState = {
  isUser: null,
  isConsultant: null,
  hasProposal: false,
  hasSubmittedEstimate: false,
  hasProposalAccepted: false,
}

export default function applicationRolesReducer(state = initialState, action) {
  switch (action.type) {
    case applicationRoles.USER_WITH_ESTIMATES:
      return {
        ...state,
        hasProposal: false,
        hasSubmittedEstimate: false,
        hasProposalAccepted: false,
      }
    case applicationRoles.USER_WITH_PROPOSAL_SETUP:
      return {
        ...state,
        hasProposal: true,
        hasSubmittedEstimate: true,
        hasProposalAccepted: false,
      }
    case applicationRoles.USER_WITH_PROPOSAL_ACCEPTED:
      return {
        ...state,
        hasProposal: true,
        hasSubmittedEstimate: true,
        hasProposalAccepted: true,
      }
    case applicationRoles.USER_ACCEPTED_ESTIMATE:
      return {
        ...state,
        hasProposal: false,
        hasSubmittedEstimate: true,
        hasProposalAccepted: false,
      }
    case applicationRoles.CONSULTANT:
      return {
        ...state,
        isUser: false,
        isConsultant: true,
      }
    case applicationRoles.CUSTOMER:
      return {
        ...state,
        isUser: true,
        isConsultant: false,
      }
    default:
      return state
  }
}
